import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { hasMatch } from './projectUtils.js';
import { projectFormatter } from './projectFormatter.js';


export const ProjectCost = createReactClass({
    propTypes: {
        project: PropTypes.object.isRequired,
        amountGiven: PropTypes.number,
    },

    render: function () {
        const project = this.props.project;
        const incomplete = parseFloat(project.costToComplete) > 0;
        const className = (hasMatch(this.props.project) ? 'cost-has-match ' : '');

        const amountGiven = this.props.amountGiven ? <div>You gave ${this.props.amountGiven}!</div> : null;

        return (
            <div>
                {amountGiven}
                <span className={className}>
                    <span className="project-cost">
                        {projectFormatter.formatCurrency(incomplete ? project.costToComplete : project.totalPrice)}
                    </span>
                    {incomplete ? ' still needed' : ' donated'}
                </span>
            </div>
        );
    },
});
